import { axiosInstance } from "./axios";

export const GetLastDayOfUse = async() => {
  return await axiosInstance
    .get("/corporations/lastDayOfUse")
    .then(res =>  res.data.data)
    .catch((err) => console.log("e", err));
};
